import { useQuery } from '@tanstack/react-query';
import { fetchHealth, fetchHealthInfo } from '../api/healthApi';

/**
 * Fetches backend liveness. The query is cached across consumers and does not
 * poll so QA databases can scale down when nobody is actively using the app.
 */
export function useHealth() {
  return useQuery({
    queryKey: ['health'],
    queryFn: fetchHealth,
    staleTime: 30_000,
    retry: false,
  });
}

/**
 * Fetches version/system info once (no polling needed).
 */
export function useHealthInfo() {
  return useQuery({
    queryKey: ['health', 'info'],
    queryFn: fetchHealthInfo,
    staleTime: 5 * 60_000,
    retry: false,
  });
}
